import { Navigate, useLocation } from 'react-router-dom';
import type { PropsWithChildren } from 'react';
import { useAuth } from '../hooks/useAuth';

const BatchExportRoute = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const canBatchExport = Boolean(user?.canBatchExport ?? user?.can_batch_export ?? user?.isStaff ?? user?.is_staff);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!canBatchExport) {
    return <Navigate to="/app/reports" replace />;
  }

  return <>{children}</>;
};

export default BatchExportRoute;
